import { Box, Flex, Text } from "@chakra-ui/react";
import React from "react";
import { TaxOutcomeDetail } from "../../../../../helper/aggregateLedgerTaxOutcomes";
import { InfoToolTip } from "../../../../atoms/InfoToolTip";
import { SkeletonRect } from "../../../../atoms/Skeletons";
import {
  SectionContainer,
  SectionTitle,
  TransactionOverviewPaddingX,
} from "./SectionTitle";
import { TaxDetailsHeaders, TaxDetailsRow } from "./TaxDetails";

export const TransactionTaxSection = React.memo(function TransactionTaxSection({
  taxOutcomeDetails,
  isLoading,
}: {
  taxOutcomeDetails: TaxOutcomeDetail[];
  isLoading: boolean;
}): React.ReactElement {
  return (
    <Box>
      <SectionContainer>
        <SectionTitle>Tax outcomes</SectionTitle>
        <InfoToolTip
          label="This transaction resulted in the following tax outcomes"
          wrap
        />
      </SectionContainer>

      <TaxDetailsHeaders />

      {taxOutcomeDetails.map((taxOutcomeDetail, index) => (
        <TaxDetailsRow key={index} {...taxOutcomeDetail} />
      ))}

      {taxOutcomeDetails.length === 0 && (
        <Flex w="full" justify="center" py={4} px={TransactionOverviewPaddingX}>
          <SkeletonRect isLoaded={!isLoading}>
            <Text color="gray.600">No tax outcomes for this transaction.</Text>
          </SkeletonRect>
        </Flex>
      )}
    </Box>
  );
});
